export const TRONSCAN_TRANSACTION_LINK = 'https://tronscan.org/#/transaction';
